import { Box, CircularProgress, Paper, Skeleton, Stack, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";

export const GigaBusyOverlay = ({ label }) => (
	<Box
		sx={{
			position: "absolute",
			inset: 0,
			zIndex: 2,
			bgcolor: "rgba(255,255,255,0.72)",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			gap: 1,
			minHeight: 160,
		}}>
		<CircularProgress size={18} />
		<Typography fontSize={13.5} fontWeight={600} color={grey[700]}>
			{label}
		</Typography>
	</Box>
);

export const GigaRunPageSkeleton = () => (
	<Box sx={{ p: 2, maxWidth: 1400, mx: "auto", bgcolor: grey[50], minHeight: "100%" }}>
		<Stack direction="row" alignItems="center" justifyContent="space-between" mb={2} gap={1}>
			<Stack direction="row" alignItems="center" spacing={1.5}>
				<Skeleton variant="rounded" width={88} height={32} />
				<Box>
					<Skeleton variant="text" width={220} height={32} />
					<Skeleton variant="text" width={280} height={18} />
				</Box>
			</Stack>
			<Skeleton variant="rounded" width={72} height={22} />
		</Stack>
		<Paper elevation={0} sx={{ border: `1px solid ${grey[200]}`, borderRadius: 2, p: 2 }}>
			<Stack direction="row" spacing={2} mb={2}>
				<Skeleton variant="rounded" width={72} height={28} />
				<Skeleton variant="rounded" width={72} height={28} />
				<Skeleton variant="rounded" width={96} height={28} />
				<Skeleton variant="rounded" width={80} height={28} />
			</Stack>
			<Skeleton variant="rounded" width="100%" height={180} sx={{ mb: 2 }} />
			{Array.from({ length: 6 }).map((_, idx) => (
				<Skeleton key={idx} variant="rounded" width="100%" height={36} sx={{ mb: 1 }} />
			))}
		</Paper>
	</Box>
);
